var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiempoAtencionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6,33.4l2.8-2.8L26,23.2V14h-4v10.8L30.6,33.4z M24,44c-2.8,0-5.4-0.5-7.8-1.6s-4.6-2.5-6.4-4.3 c-1.8-1.8-3.2-3.9-4.3-6.4S4,26.8,4,24s0.5-5.4,1.6-7.8s2.5-4.6,4.3-6.4s3.9-3.2,6.4-4.3S21.2,4,24,4s5.4,0.5,7.8,1.6 s4.5,2.5,6.4,4.3c1.8,1.8,3.2,3.9,4.3,6.4s1.6,5,1.6,7.8s-0.5,5.4-1.6,7.8s-2.5,4.5-4.3,6.4c-1.8,1.8-3.9,3.2-6.4,4.3S26.8,44,24,44 z M24,40c4.4,0,8.2-1.6,11.3-4.7C38.4,32.2,40,28.4,40,24s-1.6-8.2-4.7-11.3S28.4,8,24,8s-8.2,1.6-11.3,4.7S8,19.6,8,24 s1.6,8.2,4.7,11.3C15.8,38.4,19.6,40,24,40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiempoAtencionIcon);
export default __webpack_public_path__ + "static/media/TiempoAtencionIcon.7a678958dbb9febe308a074e0ade1c07.svg";
export { ForwardRef as ReactComponent };